/** Joueurs bots d'équipe (bot1 … bot9), aligné sur webtarotAPI. */
export function isBotPseudo(pseudo: string): boolean {
  return /^bot[1-9]$/i.test(pseudo.replace(/¶/g, ' ').trim());
}
